/* RESPONSIBLE TEAM: team-channels */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { isBlank } from '@ember/utils';
import BaseValidator from 'ember-cp-validations/validators/base';

const EmailSubjectNotEmpty = BaseValidator.extend({
  validate(value, options, model) {
    if (isBlank(value) && model.get('isEmail')) {
      return 'Add a subject line to your message';
    }
    return true;
  },
});

EmailSubjectNotEmpty.reopenClass({
  getDependentsFor() {
    return ['model.isEmail'];
  },
});

export default EmailSubjectNotEmpty;
